import { Button, Grid, IconButton, Stack, styled } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

const MenuButton = styled(Button)(() => ({
  color: NEW_COLORS.GRAYSCALE[600],
  fontWeight: 400,
  fontSize: 14,
  '& .MuiButton-startIcon': {
    color: NEW_COLORS.SECONDARY[500],
  },
}));

const MenuButtonMobile = styled(Button)(() => ({
  color: NEW_COLORS.GRAYSCALE[700],
  all: 'unset',
  cursor: 'pointer',
  width: '24px',
  height: '24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& .MuiButton-startIcon': {
    color: NEW_COLORS.SECONDARY[500],
    margin: 0,
  },
}));

const ButtonHomeLogo = styled(Button)<{ isLoggedUser?: boolean }>(
  ({ isLoggedUser }) => ({
    cursor: isLoggedUser ? 'pointer' : 'auto',
  }),
);

const BackButtonMobile = styled(Button)<{
  isBackofficeUser?: boolean;
}>(({ isBackofficeUser }) => {
  return {
    color: !isBackofficeUser
      ? NEW_COLORS.GRAYSCALE[600]
      : NEW_COLORS.BASE.WHITE,
    all: 'unset',
    cursor: 'pointer',
    display: 'flex',
    minWidth: 'auto',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiButton-startIcon': {
      color: !isBackofficeUser
        ? NEW_COLORS.GRAYSCALE[600]
        : NEW_COLORS.BASE.WHITE,
      margin: 0,
    },
  };
});

const StyledStack = styled(Stack)<{ hasConditionalItem: boolean }>(
  ({ hasConditionalItem }) => ({
    position: 'relative',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: hasConditionalItem ? 'space-between' : 'flex-end',
    width: '100%',
  }),
);

const MobileHiddenStack = styled(Stack)(({ theme }) => ({
  flex: 1,
  gap: '8px',
  [theme.breakpoints.down('lg')]: {
    display: 'none',
  },
}));

const HeaderMobileColored = styled(Grid)<{
  isBackofficeUser?: boolean;
}>(({ isBackofficeUser }) => ({
  background: isBackofficeUser
    ? NEW_COLORS.GRAYSCALE[800]
    : NEW_COLORS.BASE.WHITE,
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  position: 'relative',
  alignItems: 'center',
}));

const CompanySelectedInfo = styled(Stack)(() => ({
  borderRadius: '0 0 8px 8px',
  boxShadow: '0px 8px 8px 0px #0000001F',
  minHeight: '60px',
  padding: '11px 24px 16px 24px',
  flexDirection: 'row',
}));

const EditButton = styled(IconButton)(() => ({
  '&.MuiIconButton-root': {
    border: `1px solid ${NEW_COLORS.PRIMARY[500]}`,
    width: '20px',
    height: '20px',

    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

export {
  EditButton,
  CompanySelectedInfo,
  HeaderMobileColored,
  MobileHiddenStack,
  StyledStack,
  MenuButtonMobile,
  MenuButton,
  BackButtonMobile,
  ButtonHomeLogo,
};
